<template>
    <div>
        <tickets 
        :tickets="tickets"
        :alltickets="allTickets"
        :ticketcategories="ticketCategories" 
        :ticketcategoryitems="ticketCategoryItems" 
        :users="organisationUsers"
        :switchingcentres="switchingCentres"
        :locationnodes="locationNodes"
        :locationnetworks="locationNetworks"
        :locations="locations"
        />
    </div>
</template>
<script>
import Api from '@/services/Api.js'
import Tickets from '@/components/Tickets.vue'
export default {
    components: {
        tickets: Tickets
    },
    data(){
        return {
            tickets: [],
            allTickets: [],
            ticketCategories: [],
            ticketCategoryItems: [],
            organisationUsers: [],
            switchingCentres: [],
            locationNodes: [],
            locationNetworks: [],
            locations: []
        }
    },
    created(){
        this.initialise()
    },
    methods: {
        async initialise(){
            //this.fetchTickets()
            //await this.fetchOrgContacts()
            this.fetchTicketCategories()
            this.fetchTicketCategoryItems()            
           // this.fetchSwitchingCentres()
           // this.fetchLocationNodes()
           //this.fetchLocationNetworks()
           this.fetchLocations()
        },
        fetchTickets(){
            Api()
            .get('/ticket')
            .then(async response=>{
                
        let result = await response.data.map(x=>({key: x.id, highlight: true, dates: x.dueDate, customData: {
            'id': x.id,
            'currentStatus': x.currentStatus,
            'colour': x.ticketCategoryItem.colour,
            'importance': x.importance,
            'description': x.description,
            'dueDate': x.dueDate,
            'dueTime': x.dueTime,
            'isComplete': x.isComplete,
            'isActive': x.isActive,
            'isDeleted': x.isDeleted,
            'createdAt': "2020-02-12T06:18:19.000Z",
            'updatedAt': "2020-02-12T06:18:19.000Z",
            'ticketCategoryItemId': x.ticketCategoryItemId,
            'createdById': x.createdById,
            'assignedToId': x.assignedToId,
            'resolvedById': x.resolvedById,
            'organisationId': x.organisationId,
            'locationId': x.locationId,
            'locationNetworkId': x.locationNetworkId,
            'locationNodeId': x.locationNodeId,
            'switchingCentreId': x.switchingCentreId,
            'createdBy': x.createdBy,
            'resolvedBy': x.resolvedBy,
            'assignedTo': x.assignedTo,
            'location': x.location,
            'locationNetwork': x.locationNetwork,
            'locationNode': x.locationNode,
            'switchingCentre': x.switchingCentre,
            'ticketCategoryItem': x.ticketCategoryItem,
            'ticketCategoryItem': x.ticketCategoryItem,
            'isSystemGenerated': x.isSystemGenerated
        }}))
        console.log(result)
        this.tickets=result
        this.allTickets=response.data
            })
        },
        fetchTicketCategories(){
            Api()
            .get('/ticketCategory')
            .then(response=>{
                this.ticketCategories = response.data
            })
        },
        fetchTicketCategoryItems(){
            Api()
            .get('/ticketCategoryItem')
            .then(response=>{
                this.ticketCategoryItems = response.data
            })
        },
        fetchOrgContacts(){
      this.organisationUsers=[]
        Api()
        .get('/organisationContact')
        .then(async response=>{
            this.organisationUsers = response.data.filter(function(el){
                return el.userType !=='endClient'
            })
            let contactArray = await this.organisationUsers.map(x=>x.contact)
            this.organisationUsers = contactArray
        })
    },
    fetchSwitchingCentres(){
        Api()
        .get('/switchingCentres')
        .then(response=>{
            this.switchingCentres = response.data
        })
    },
    fetchLocationNodes(){
        Api()
        .get('/locationNodes')
        .then(response=>{
            this.locationNodes = response.data
        })
    },
    fetchLocationNetworks(){
        Api()
        .get('/locationNetworks')
        .then(response=>{
            this.locationNetworks = response.data
        })
    },
    fetchLocations(){
        Api()
        .get('/locations')
        .then(response=>{
            this.locations = response.data
        })
    }

    }
    
}
</script>